<div class="vo-central-content">
  <div class="vo-main-content">
    <div class="vo-left-column">
      <div class="vo-heading-regular-28 position-relative">
        <span [innerHtml]="referenceDataLabels.HelpCenterPrivacy | localizeLabel"></span>
        <span #privacyPolicyPanel class="position-absolute top-n100"></span>
      </div>
      <div
        class="default-user-agent vo-link-inside"
        [innerHtml]="referenceDataLabels.HelpCenterPrivacyContent | localizeLabel | toTrustedHtml"
      ></div>

      <div class="vo-heading-regular-28 mt-30 position-relative">
        <span [innerHtml]="referenceDataLabels.HelpCenterWebAccessibility | localizeLabel"></span>
        <span #webAccPanel class="position-absolute top-n100"></span>
      </div>
      <div
        class="default-user-agent vo-link-inside"
        [innerHtml]="referenceDataLabels.HelpCenterWebAccessibilityContent | localizeLabel | toTrustedHtml"
      ></div>
    </div>

    <div class="vo-right-column vo-sticky-content vo-sticky-content--small-sticky-header">
      <div class="mb-30">
        <div
          class="vo-heading-regular-16"
          [innerHtml]="referenceDataLabels.HelpCenterSectionContains | localizeLabel"
        ></div>
        <div
          class="vo-body-regular-14 vo-link my-15"
          (click)="privacyPolicyPanel.scrollIntoView({ behavior: 'smooth' })"
          [innerHtml]="referenceDataLabels.HelpCenterPrivacy | localizeLabel"
        ></div>
        <div
          class="vo-body-regular-14 vo-link my-15"
          (click)="webAccPanel.scrollIntoView({ behavior: 'smooth' })"
          [innerHtml]="referenceDataLabels.HelpCenterAccessibility | localizeLabel"
        ></div>
      </div>
      <div class="vo-panel vo-panel-white text-break">
        <div class="vo-heading-regular-16" [innerHtml]="referenceDataLabels.ContactUs | localizeLabel"></div>
        <div
          class="vo-body-regular-14"
          [innerHtml]="referenceDataLabels.AgentProfileContactUsText | localizeLabel"
        ></div>
      </div>
    </div>
  </div>
</div>
